import Glide from "@glidejs/glide"

class SiteSlider {
  constructor() {
    if(document.querySelector("#glide2")) {
      var topmenudestop = new Glide("#glide2", {
        // type: 'slider',
        type: 'carousel',
        gap: 0,
        focusAt: 'center',
        perView: 1.5,
        // startAt: 0,
        // hoverpause: false,
        breakpoints: {
          700: {
            perView: 1
          }
        }
      })
      // topmenudestop.on("run", () => {
      //   var focusAt = "center";
      //   if (glide.index === 0) focusAt = 0;
      //   glide.update({
      //     focusAt: focusAt
      //   });
      // });
      
      topmenudestop.mount()
          
      const mutator = function (Glide, Components, Events) {
        return {
          modify(translate) {

            // First slide
            if (Glide.index === 0) {

              // Move slide 20 pixels from left
              return translate - 180;

            // Last slide
            } else if (Glide.index === Components.Sizes.length - 1) {

              // Move slide 20 pixels from right
              return translate - (Components.Sizes.width - Components.Sizes.slideWidth) + 180;
            
            // Other slides
            } else {

                // Center slide
                return translate - (Components.Sizes.width - Components.Sizes.slideWidth) / 2;

            }
          },
        };
      };

      // topmenudestop.mutate([mutator]).mount();
    }



  }  
}

export default SiteSlider